import { Configuration } from './types';

const config: Record<string, Configuration> = {
  sandbox: {
    application: 'transactions',
    basePath: '/usis/transactions',
    port: 3000,
    sslPort: 3443,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Credentials': true,
      'X-TRP-Requested-With': 'XMLHttpRequest',
      'X-Frame-Options': 'SAMEORIGIN',
    },
    vault: 'https://vault.dev.troweprice.io:8200',
    api: {
      host: 'https://api.dev.troweprice.com',
    },
    url: window?.location
      ? `${window.location.protocol}//${window.location.hostname}:${window.location.port}`
      : 'http://localhost:3000',
    clxUrl: 'https://www3dev.troweprice.com',
    individual: 'https://individual.troweprice.com',
    pdUrl: '/clx-tk/token-exchange/redirect/transactions',
    rmlUrl: 'https://wwwstage.troweprice.com',
    userUrl:
      'https://www3qual.troweprice.com/usis/personal-investing/relationship-manager/',
    foresee: 'https://preview-survey.foresee.com/f/rPnI1gAlIk',
    cui: {
      url: 'https://apidev.awstrp.net/cuirouter/send',
      key: 'b3RaU2rRzZoI674Zv7wgkeQlZAZjrcfh',
    },
    debug: {
      enableReduxDevTools: true,
    },
  },
  sandboxTertiary: {
    application: 'transactions',
    basePath: '/usis/beta-transactions',
    port: 3000,
    sslPort: 3443,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Credentials': true,
      'X-TRP-Requested-With': 'XMLHttpRequest',
      'X-Frame-Options': 'SAMEORIGIN',
    },
    vault: 'https://vault.dev.troweprice.io:8200',
    api: {
      host: 'https://api.dev.awstrp.net',
    },
    url:
      window && window.location
        ? `${window.location.protocol}//${window.location.hostname}:${window.location.port}`
        : 'http://localhost:3000',
    clxUrl: 'https://www3dev.troweprice.com',
    individual: 'https://individual.troweprice.com',
    pdUrl: '/clx-tk/token-exchange/redirect/transactions',
    rmlUrl: 'https://wwwstage.troweprice.com',
    userUrl:
      'https://www3qual.troweprice.com/usis/personal-investing/relationship-manager/',
    foresee: 'https://preview-survey.foresee.com/f/rPnI1gAlIk',
    cui: {
      url: 'https://apidev.awstrp.net/cuirouter/send',
      key: 'b3RaU2rRzZoI674Zv7wgkeQlZAZjrcfh',
    },
    debug: {
      enableReduxDevTools: true,
    },
  },
  dev: {
    application: 'transactions',
    basePath: '/usis/transactions',
    port: 3000,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Credentials': true,
      'X-TRP-Requested-With': 'XMLHttpRequest',
    },
    debug: {
      enableReduxDevTools: true,
    },
    vault: 'https://vault.dev.troweprice.io:8200',
    api: {
      host: 'https://api.dev.troweprice.com',
      internal: 'https://api.dev.awstrp.net',
    },
    url: 'https://wwwdev.troweprice.com',
    clxUrl: 'https://www3dev.troweprice.com',
    caimUrl: 'https://wwwdev.troweprice.com/v0/ciam-public/me',
    individual: 'https://individual.troweprice.com',
    internal: {
      host: '',
    },
    pdUrl: '/clx-tk/token-exchange/redirect/transactions',
    rmlUrl: 'https://wwwdev.troweprice.com',
    userUrl:
      'https://www3qual.troweprice.com/usis/personal-investing/relationship-manager/',
    foresee: 'https://preview-survey.foresee.com/f/rPnI1gAlIk',
    cui: {
      url: 'https://apidev.awstrp.net/cuirouter/send',
      key: 'b3RaU2rRzZoI674Zv7wgkeQlZAZjrcfh',
    },
    serviceHost: 'https://api.dev.awstrp.net/',
    applicationRequiredEntitlements: [],
    optionalPanelEntitlements: ['iusers'],
    allowedAuthentication: 'both',
    localhostAuthType: 'external',
    baseEnvHost: 'https://api.dev.awstrp.net/',
    customerWebViewEnabled: true,
    authorizePath: 'nitro_oauth-common-callback/login',
    sandboxAuthCookieEnabled: false,
  },
  stage: {
    application: 'transactions',
    basePath: '/usis/transactions',
    port: 3000,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Credentials': true,
      'X-TRP-Requested-With': 'XMLHttpRequest',
    },
    vault: 'https://vault.stage.troweprice.io:8200',
    api: {
      host: 'https://api.confidence.troweprice.com',
      internal: 'https://api.stage.awstrp.net',
    },
    url: 'https://wwwstage.troweprice.com',
    clxUrl: 'https://www3qual.troweprice.com',
    individual: 'https://individual.troweprice.com',
    pdUrl: '/clx-tk/token-exchange/redirect/transactions',
    rmlUrl: 'https://wwwstage.troweprice.com',
    userUrl:
      'https://www3qual.troweprice.com/usis/personal-investing/relationship-manager/',
    foresee: 'https://survey.foresee.com/f/rPnI1gAlIk',
    cui: {
      url: 'https://api.stage.awstrp.net/cuirouter/send',
      key: 'GAL1xfkY5O49a9AK2EdV6eKIy3aaVMU3',
    },
    debug: {
      enableReduxDevTools: true,
    },
  },
  prod: {
    application: 'transactions',
    basePath: '/usis/transactions',
    port: 3000,
    api: {
      host: 'https://api.public.troweprice.com',
      internal: 'https://api.prod.awstrp.net',
    },
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Credentials': true,
      'X-TRP-Requested-With': 'XMLHttpRequest',
    },
    url: 'https://www.troweprice.com',
    individual: 'https://individual.troweprice.com',
    clxUrl: 'https://www3.troweprice.com',
    pdUrl: '/clx-tk/token-exchange/redirect/transactions',
    rmlUrl: 'https://www.troweprice.com',
    userUrl:
      'https://www3.troweprice.com/usis/personal-investing/relationship-manager/',
    foresee: 'https://survey.foresee.com/f/rPnI1gAlIk',
    cui: {
      url: 'https://api.public.troweprice.com/cuirouter/send',
      key: 'lmtPEUGwuHn7aOPLmOEkAGkTyVfG9GYf',
    },
    debug: {
      enableReduxDevTools: false,
    },
    vault: 'https://vault.troweprice.io:8200',
    env: 'prod',
  },
};

let env: Partial<Configuration> = {};
// secondary flag doesn't actually pass since __CONFIG__ is evaluated during build
if (
  typeof window.location !== 'undefined' &&
  !window.location.host.includes('localhost')
) {
  // eslint-disable-line no-restricted-globals
  if (window.location.host.includes('dev')) {
    // eslint-disable-line no-restricted-globals
    env = config['dev'];
  } else if (window.location.host.includes('stage')) {
    // eslint-disable-line no-restricted-globals
    env = config['stage'];
    if (window.location.pathname.includes('beta')) {
      env.basePath = '/usis/beta-transactions';
    } else if (window.location.pathname.includes('salesforce-transactions')) {
      env.basePath = '/usis/salesforce-transactions';
    }
  } else {
    env = config['prod'];
  }
  if (
    window.location.host.includes('awstrp') && // eslint-disable-line no-restricted-globals
    !(env.url as string)?.includes('awstrp')
  ) {
    env.url = `https://${window.location.host}`; // eslint-disable-line no-restricted-globals
  }
} else {
  env = config['dev'];
  if (window.location.pathname.includes('beta')) {
    env.basePath = '/usis/beta-transactions';
  }
}
export default env;
